import React from 'react'

import MenuSection from '../MenuSection'
import UserSearch from '../UserSearch'

import {
  CLIENT_OPTIONS,
  ALL_CLIENTS,
  TASKS_FOR_A_CLIENT
} from '../../helpers/parse'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'

type ClientFilterProps = {
  checkFilters?: boolean
  hideViews?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const ClientFilter: React.FC<ClientFilterProps> = ({ hideViews, ...props }) => {
  const { state, handleChange } = useTaskFilters()
  const { user } = useEnvironment()

  return (
    <MenuSection
      title='Client'
      options={CLIENT_OPTIONS}
      value={state.clientValue}
      setValue={handleChange('clientValue')}
      unassignedOpt={ALL_CLIENTS}
      noBorder={hideViews}
      {...props}
    >
      {state.clientValue === TASKS_FOR_A_CLIENT && (
        <UserSearch
          userID={user?.id}
          value={state.clientID}
          setValue={handleChange('clientID')}
          external
          startOpen
        />
      )}
    </MenuSection>
  )
}

export default ClientFilter
